import React from "react";
import SimulacionIcon from '../icons/SimulacionIcon';
import AsesoriaIcon from '../icons/AsesoriaIcon';
import PencilIcon from '../icons/PencilIcon';
import { useTranslationContext } from "../context/TranslationsProvider";

const CuotaDisplay = ({ monto, plazo, tasaMensual, tasaEA, cuota, seguro, valorSeguro, solicitudCreditoUrl, solicitudAsesoriaUrl }) => {
    const { translations } = useTranslationContext();
    const t = (key, fallback) => translations[key] || fallback;
    
    const formatoCOP = (valor) => {
        const numeroValido = Number(valor) || 0;
        return new Intl.NumberFormat("es-CO", {
            style: "currency",
            currency: "COP",
            minimumFractionDigits: 0
        }).format(numeroValido);
    };

    const montoNumerico = Number(monto) || 0;
    const cuotaNumerico = Number(cuota) || 0;
    const valorSeguroNumerico = Number(valorSeguro) || 0;
    const tasaEADisplay = tasaEA || '0.00';
    
    const cuotaSinSeguro = seguro ? cuotaNumerico - valorSeguroNumerico : cuotaNumerico;
    const valorSeguroDisplay = seguro ? valorSeguroNumerico : 0;

    return (
        <div className="resultado-simulacion">
            <h4 className="resultado-titulo" style={{ textAlign: 'center', fontSize: '24px' }}>{t('bdo-libranza-title', 'Solicítalo y te lo aprobamos en dos minutos')}</h4>
            <p className="resultado-descripcion">
                {t('bdo-libranza-description-simulation-result', 'Aquí va la descripción del mensaje.')}
            </p>
            <div className="tarjeta-simulacion">
                <div className="encabezado-simulacion">
                    <span className="tu-simulacion-tag">
                        <SimulacionIcon />
                        <p style={{ fontSize: '14px' }}>
                            {t('bdo-libranza-label-your-simulation', 'Tu simulación')}
                        </p>
                    </span>
                </div>
                <div className="detalles-simulacion">
                    <span>{t('bdo-libranza-label-term-result', 'Plazo')}: {plazo} meses</span>
                    <div className="tasas-container">
                        <span>{t('bdo-libranza-label-rate-result', 'Tasa')}: {tasaEADisplay}% N.M.V</span>
                    </div>
                </div>
                <div className="monto-prestamo">
                    <span className="monto-label">{t('bdo-libranza-label-loan-amount', 'Te prestamos')}</span>
                    <span className="monto-valor">{formatoCOP(montoNumerico)}</span>
                </div>
                <div className="seguro-info">
                    <div className="valor-cuota-seguro">
                        <span>{t('bdo-libranza-label-payment-without-insurance', 'Valor cuota sin seguro')}</span>
                        <span>{formatoCOP(cuotaSinSeguro)}</span>
                    </div>
                    <div className="seguro-cuota">
                        <span className="seguro-cuota-texto">{t('bdo-libranza-label-protected-insurance', 'Seguro de cuota protegida')}</span>
                        <span className="seguro-cuota-valor">+ {formatoCOP(valorSeguroDisplay)}</span>
                    </div>
                </div>
                <div className="divider"></div>
                <div className="cuota-total">
                    <span>{t('bdo-libranza-label-monthly-payment', 'Cuota mensual')}</span>
                    <span className="valor-total">{formatoCOP(cuotaNumerico)}</span>
                </div>
                <div className="solicitar-credito-container">
                    <a href={solicitudCreditoUrl} target="_blank" rel="noopener noreferrer" className="solicitar-credito">{t('bdo-libranza-button-request-loan', 'Solicita tu crédito')}</a>
                </div>
            
            </div>
            <div className="edit-simulation-container">
                <button 
                    className="edit-simulation-button"
                    onClick={() => {
                        const formElement = document.querySelector('.simulator-form');
                        if (formElement) {
                            formElement.scrollIntoView({ behavior: 'smooth' });
                        }
                    }}
                    aria-label={t('bdo-libranza-label-edit-simulation', 'Editar simulación')}
                >
                    <PencilIcon />
                    <span>{t('bdo-libranza-label-edit-simulation', 'Editar simulación')}</span>
                </button>
            </div>
            <div className="solicitar-asesoria-container">
                <a href={solicitudAsesoriaUrl} target="_blank" rel="noopener noreferrer" className="solicitar-asesoria">
                    <AsesoriaIcon />
                    <span>{t('bdo-libranza-button-request-advice', 'Solicitar asesoría')}</span>
                </a>
            </div>
        </div>
    );
};

export default CuotaDisplay;
